var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuex-table',{attrs:{"title":_vm.$t('core.payment.titles.operation_history'),"fields":_vm.fields,"auto_start":true,"table_store":"core/payments/table"},scopedSlots:_vm._u([{key:"amount",fn:function(ref){
var item = ref.item;
return [_c('amount',{attrs:{"amount":item.amount}})]}},{key:"type",fn:function(ref){
var item = ref.item;
return [_c('type',{attrs:{"item":item}})]}},{key:"state",fn:function(ref){
var item = ref.item;
return [_c('state-badge',{attrs:{"value":item.state}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }